import React, { useState, useCallback } from 'react';
import { Grid, Dialog, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useRecoilValue } from 'recoil';
import { Add } from '@material-ui/icons';

import { usersQuery } from '../../features/user';
import { UserCard } from './UserCard';
import { Transition } from './Transition';
import { UserForm } from './UserForm';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		marginTop: theme.spacing(2),
	},
	button: {
		margin: theme.spacing(2),
	},
}));

export function UserList() {
	const classes = useStyles();
	const initialUsers = useRecoilValue(usersQuery);
	const [users, setUsers] = useState(initialUsers);
	const [creating, setCreating] = useState(false);
	const { t } = useTranslation();

	const handleDeleteUser = useCallback((user_id: string) => {
		setUsers((users) => users.filter((user) => user.user_id !== user_id));
	}, []);

	const handleUserCreate = useCallback((user) => {
		setUsers((users) => [...users, user]);
	}, []);

	return (
		<Grid className={classes.root} container direction="column" spacing={2}>
			<Grid container direction="column" alignItems="flex-end">
				<Grid item className={classes.button}>
					<Button
						variant="outlined"
						aria-label="create"
						startIcon={<Add />}
						onClick={() => setCreating(true)}
					>
						{t('userCard.createUser')}
					</Button>
				</Grid>
			</Grid>
			<Grid container spacing={2}>
				{[...users]
					.sort((userA, userB) =>
						userA.username.localeCompare(userB.username)
					)
					.map((user) => (
						<UserCard
							key={user.user_id}
							user={user}
							onDelete={handleDeleteUser}
						/>
					))}
			</Grid>
			<Dialog
				maxWidth="sm"
				fullWidth
				open={creating}
				TransitionComponent={Transition}
				keepMounted
				onClose={() => setCreating(false)}
				aria-labelledby="edit-dialog-slide-title"
				aria-describedby="edit-dialog-slide-description"
			>
				<UserForm
					user={null}
					onClose={() => setCreating(false)}
					onUserCreate={handleUserCreate}
				/>
			</Dialog>
		</Grid>
	);
}
